export interface IAlert {
    field: string[];
    message: string;
}

export interface IAlertHolder {
    idGlobal: string;
    goodsName: string;
    alerts?: IAlert[];
}

export interface IErrorItem {
    idGlobal: string;
    goodsName: string;
    alerts: IAlert[];
}

export const addAlert = <T extends IAlertHolder>(
    item: T,
    alert: IAlert
): T => {
    const alerts = item.alerts ?? [];

    // Чтобы не было дублей
    const exists = alerts.some(
        x =>
            x.message === alert.message &&
            x.field.join('|') === alert.field.join('|')
    );

    if (exists) {
        return item;
    }

    return {
        ...item,
        alerts: [...alerts, alert]
    };
};

export const removeAlert = <T extends IAlertHolder>(
    item: T,
    message: string
): T => ({
    ...item,
    alerts: (item.alerts ?? []).filter(x => x.message !== message)
});

//обновление ошибок в displayItems
export const updateAlert = <T extends IAlertHolder>(
    item: T,
    alert: IAlert,
    enabled: boolean
): T => {
    if (enabled) {
        return addAlert(item, alert);
    }

    return removeAlert(item, alert.message);
};

//получение item-ов содержащих ошибки для передачи в модалку AlertsModal
export const getItemsWithErrors = <T extends IAlertHolder>(items: T[]): IErrorItem[] => {
    return items
        .filter(item => (item.alerts?.length ?? 0) > 0)
        .map(item => ({
            idGlobal: item.idGlobal,
            goodsName: item.goodsName,
            alerts: item.alerts ?? []
        }));
};